/** @jsxImportSource @emotion/react */
import React, { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ModalMultiSelectField, SelectItem } from '../../../shared/ModalMultiSelectField';
import { useAppDispatch } from '../../../core/store';
import { fetchStatuses, selectIsFetching, selectStatuses } from '../store/assessmentReportResultsSlice';
import { AssessmentReportFilters } from '../model/assessmentReportQueryParams';

interface StatusMultiSelectFieldProps {
  filters: AssessmentReportFilters;
  defaultValue?: string[];
  editable?: boolean;
  onUpdate?: (brand: string[]) => void;
}

export function StatusMultiSelectField({
  filters,
  defaultValue = [],
  editable = false,
  onUpdate,
}: StatusMultiSelectFieldProps) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  useEffect(() => {
    if (editable) {
      dispatch(fetchStatuses(filters));
    }
  }, [dispatch, editable, filters]);

  const items = useSelector(selectStatuses);
  const isFetching = useSelector(selectIsFetching);

  const toSelectItem = useCallback(
    (item: string): SelectItem => {
      return {
        code: item,
        description: t(`assessment.status.${item}`),
      };
    },
    [t]
  );

  const toString = (item: SelectItem): string => {
    return item.code;
  };

  return (
    <ModalMultiSelectField
      icon='exchange'
      loading={isFetching}
      defaultValue={defaultValue != null ? defaultValue.map(v => toSelectItem(v)) : []}
      list={items.map((b): SelectItem => toSelectItem(b) as SelectItem)}
      title={t('assessment.report.filters.assessmentStatuses') || ''}
      editable={editable}
      onUpdateValue={(selectedBrand: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedBrand.map(i => toString(i)));
        }
      }}
    />
  );
}
